import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, notification, Select } from 'antd';
import api from '../api';
import { ListRoomsState, ListRoomsPropsInterface } from '../types';
import './Rooms.less';
import RoomForm from './RoomForm';
import LevelsForm from './LevelsForm';
import BuildingForm from './BuildingForm';
import SitesForm from './SitesForm';

class ListRooms extends Component<ListRoomsPropsInterface, ListRoomsState> {
  state: ListRoomsState;
  constructor(props) {
    super(props);
    this.state = {
      listSites: [],
      selSite: {
        id: '',
        name: '',
        defProf: null
      },
      isSiteSel: false,
      selSiteBuildsCount: 0,
      selSiteLevelsCount: 0,
      selSiteRoomsCount: 0,
      listBuilds: [],
      selBuild: {},
      isBuildSel: false,
      selBuildLevelsCount: 0,
      selBuildRoomsCount: 0,
      selLevelRoomsCount: 0,
      listLevels: [],
      selLevel: 0,
      selLevelValue: null,
      isLevelSel: false,
      listRooms: [],
      listSubtenants: [],
      listProfiles: [],
      useMainProfileSite: false,
      useMainProfileBuild: false,
      useMainProfileLevel: false,
      siteProf: '',
      levelProf: '',
      selRoom: {}
    };
    this.handleSiteChange = this.handleSiteChange.bind(this);
    this.handleBuildChange = this.handleBuildChange.bind(this);
    this.handleBuildingEUIChange = this.handleBuildingEUIChange.bind(this);
    this.handleLevelChange = this.handleLevelChange.bind(this);
    this.handleRoomChange = this.handleRoomChange.bind(this);
    this.handleSiteEdit = this.handleSiteEdit.bind(this);
    this.siteNameChange = this.siteNameChange.bind(this);
    this.updateBuilds = this.updateBuilds.bind(this);
    this.updateLevels = this.updateLevels.bind(this);
    this.updateRooms = this.updateRooms.bind(this);
  }

  async updateRooms(levelId: number) {
    const listRooms = await api.getRoomsByLevelId(levelId);
    const listSubtenants = await api.getSubtenants();

    this.setState({
      listRooms,
      listSubtenants,
      selRoom: {}
    });
  }

  siteProfChanged = value => {
    this.setState({
      siteProf: value
    });
  };

  levelProfChanged = value => {
    this.setState({
      levelProf: value
    });
  };

  handleCheck1 = event => {
    this.setState({
      useMainProfileSite: event.target.checked,
      siteProf: this.state?.listProfiles[0]?.id
    });
  };

  handleCheck2 = event => {
    const [prof] = this.state.listProfiles;
    const { selBuild } = this.state;
    this.setState({
      useMainProfileBuild: !!event.target.checked,
      selBuild: {
        ...selBuild,
        defProf: prof.id
      }
    });
  };

  handleCheck3 = event => {
    this.setState({
      useMainProfileLevel: event.target.checked
    });
  };

  async componentDidMount() {
    const listSites = await api.getSites();
    const listProfiles = await api.getProfiles();
    this.setState({
      listSites,
      listProfiles
    });
    const { selSite } = this.state;
    // @ts-ignore
    if (!selSite.id && listSites.length) {
      // @ts-ignore
      document.getElementById('sitesList').selectedIndex = 0;
      this.handleSiteChange(listSites[0].id);
    } else if (selSite.id) {
      // @ts-ignore
      document.getElementById('sitesList').value = selSite.id;
      this.handleSiteChange(selSite);
    }
  }

  async updateBuilds(siteId) {
    const data = await api.getBuilds(siteId);
    const selBuild = data?.[0] || {};
    this.setState({
      listBuilds: data,
      selBuild,
      isBuildSel: data.length > 0
    });
    if (data.length > 0) {
      this.handleBuildChange(selBuild.id);
    }
  }

  updateLevels(buildId) {
    return api.getLevels(buildId).then(listLevels => {
      this.setState({
        listLevels,
        isLevelSel: listLevels.length > 0
      });
      if (listLevels.length > 0) {
        this.handleLevelChange(listLevels[0].id);
      }
    });
  }

  handleSiteChange = async value => {
    const { listSites } = this.state;
    const id = parseInt(value, 10);
    const selSite = listSites.find(site => site.id === id);
    this.setState({
      selSite,
      selSiteBuildsCount: selSite ? selSite.buildingsCount : this.state.selSiteBuildsCount,
      selSiteLevelsCount: selSite ? selSite.levelsCount : this.state.selSiteLevelsCount,
      selSiteRoomsCount: selSite ? selSite.total : this.state.selSiteRoomsCount,
      isSiteSel: true,
      isBuildSel: false,
      isLevelSel: false,
      listBuilds: [],
      listLevels: [],
      listRooms: [],
      selBuild: {},
      selLevel: 0,
      selRoom: {}
    });
    if (selSite) {
      if (selSite.defProf) {
        const sProf = selSite.defProf;
        this.setState({
          useMainProfileSite: true,
          siteProf: sProf
        });
      } else {
        this.setState({ useMainProfileSite: false });
      }
      await this.updateBuilds(selSite.id);
    }
  };

  siteNameChange = event => {
    const { selSite } = this.state;
    const name = event.target.value;

    this.setState({
      selSite: {
        ...selSite,
        name
      }
    });
  };

  handleSiteDelete = async () => {
    const { selSite, listSites } = this.state;
    try {
      await api.deleteSite(selSite.id);

      const filteredListSites = listSites.filter(item => item.id !== selSite.id);
      await this.handleSiteChange(filteredListSites?.[0]?.id);
      this.setState({
        isSiteSel: !!filteredListSites.length,
        isBuildSel: false,
        isLevelSel: false,
        selRoom: this.state.listRooms?.[0] || {},
        listSites: filteredListSites || [],
        selSite: filteredListSites?.[0] || {}
      });

      if (!filteredListSites?.length) {
        // @ts-ignore
        document.getElementById('siteListForm').reset();
      }
      notification.success({
        message: 'Deleted successfully!'
      });
    } catch (e) {
      notification.error({ message: 'Error when deleting site!' });
      console.error(e);
    }
  };

  handleSiteAdd = async () => {
    const { selSite, listSites } = this.state;

    const siteAlreadyExists = listSites.some(site => site.name === selSite.name);

    if (siteAlreadyExists) return notification.warning({ message: 'Site with such name already exists!' });

    if (selSite.name === '') {
      notification.warning({ message: 'Please type site name!' });
      return;
    }
    const data = {
      // @ts-ignore
      siteName: selSite.name,
      // @ts-ignore
      useProfile: document.getElementById('check1').checked
    };
    if (data.useProfile) {
      // @ts-ignore
      data.profileId = document.getElementById('profileSite').value;
    }
    try {
      const site = await api.addSite(data);

      notification.success({ message: 'Added successfully!' });
      const listSites = await api.getSites();

      const selectedSite = listSites.find(s => s.id === site.id);
      const areBuildingsInSite = selectedSite.buildingsCount > 0;

      this.setState({
        listSites,
        selSite: selectedSite,
        isBuildSel: areBuildingsInSite,
        listBuilds: areBuildingsInSite ? this.state.listBuilds : [],
        selBuild: areBuildingsInSite ? this.state.selSite : false
      });

      // @ts-ignore
      document.getElementById('sitesList').selectedindex = 0;
    } catch (e) {
      notification.error({
        message: `Error when add site: ${e.message}`
      });
    }
  };

  handleSiteEdit = async () => {
    const { selSite, listSites } = this.state;
    const updatedListNames = listSites.map(item => {
      if (item.id === selSite.id) {
        return { ...item, name: selSite.name };
      }
      return item;
    });

    const data = {
      siteId: this.state.selSite.id,
      name: this.state.selSite.name,
      useProfile: this.state.useMainProfileSite
    };
    if (data.useProfile) {
      // @ts-ignore
      data.profileId = document.getElementById('profileSite').value;
    }
    try {
      await api.editSite(data.siteId, data);
      await this.updateBuilds(this.state.selSite.id);
      this.setState({ listSites: updatedListNames });
      notification.success({ message: 'Edited successfully!' });
    } catch (e) {
      notification.error({ message: `Error when edit site: ${e.message}` });
    }
  };

  handleBuildChange = buildingId => {
    const { listBuilds, selBuild: build } = this.state;

    const selBuild = listBuilds.length ? listBuilds.find(b => b.id === buildingId) : build;

    this.setState({
      selBuild,
      useMainProfileBuild: selBuild && !!selBuild.defProf,
      levelProf: selBuild?.defProf,
      isBuildSel: true,
      isLevelSel: false,
      selBuildLevelsCount: selBuild?.levelsCount || 0,
      selBuildRoomsCount: selBuild?.total || 0,
      selLevelValue: null,
      selLevel: 0
    });
    if (selBuild) {
      this.updateLevels(selBuild.id);
    } else {
      this.setState({ useMainProfileBuild: false });
      const sProf = this.state.selSite.defProf;
      if (sProf !== null) {
        this.setState({
          levelProf: sProf
        });
      } else {
        this.setState({ levelProf: this.state.listProfiles[0].id });
      }
    }
  };

  handleBuildingEUIChange = event => {
    const { selBuild } = this.state;
    this.setState({
      selBuild: {
        ...selBuild,
        eui: Number(event.target.value),
        euiChanged: true
      }
    });
  };

  handleBuildingNameChange = event => {
    const { selBuild } = this.state;
    this.setState({
      selBuild: {
        ...selBuild,
        name: event.target.value
      }
    });
  };

  buildProfChanged = value => {
    const { selBuild } = this.state;
    this.setState({
      selBuild: {
        ...selBuild,
        defProf: value
      }
    });
  };

  handleLevelNameChange = event => {
    this.setState({
      selLevelValue: event.target.value
    });
  };

  handleBuildingDelete = () => {
    const { selBuild } = this.state;
    if (!selBuild.id) {
      notification.warning({
        message: 'Please select building from list!'
      });
      return;
    }
    api
      // @ts-ignore
      .deleteBuild(selBuild.id)
      .then(data => {
        this.setState({
          selSiteBuildsCount: this.state.selSiteBuildsCount - 1,
          isBuildSel: false
        });
        notification.success({ message: 'Deleted successfully!' });
        // @ts-ignore
        this.updateBuilds(this.state.selSite.id);
        this.render();
      })
      .catch(e => {
        notification.error({ message: `Error when delete building: ${e.message}` });
      });
  };

  handleBuildAdd = async () => {
    const { selBuild, useMainProfileBuild, selSite, listBuilds } = this.state;

    const buildingAlreadyExists = listBuilds.some(building => building.name === selBuild.name);

    if (buildingAlreadyExists) return notification.warning({ message: 'Building with such name already exists!' });

    if (selBuild.name === '') {
      return notification.warning({
        message: 'Please type build name!'
      });
    }
    if (useMainProfileBuild && !selBuild.defProf) {
      return notification.warning({
        message: 'Please choose energy profile!'
      });
    }
    const data = {
      ...selBuild,
      siteId: selSite.id,
      useProfile: useMainProfileBuild
    };
    try {
      await api.addBuild(data);
      this.setState({
        selSiteBuildsCount: this.state.selSiteBuildsCount + 1
      });
      notification.success({ message: 'Added successfully!' });
      // @ts-ignore
      this.updateBuilds(selSite.id);
    } catch (e) {
      notification.error({ message: `Error when add build: ${e.message}` });
    }
  };

  handleBuildingsEdit = async () => {
    const { selBuild, useMainProfileBuild, listBuilds } = this.state;
    const { id, eui, euiChanged, ...building } = selBuild;
    console.log({ state: this.state });
    if (!id) return notification.warning({ message: 'Need to add building before editing!' });

    if (eui < 150) return notification.warning({ message: 'Eui must not be less than 150!' });

    const data = {
      ...building,
      useProfile: useMainProfileBuild
      // siteId: this.state.selSite.id
    };
    if (data.useProfile) {
      // @ts-ignore
      data.profileId = parseInt(document.getElementById('buildingProfile').value, 10);
    }
    const promises = [api.editBuild(id, data)];
    if (euiChanged) {
      promises.push(api.patchBuildEUI(id, eui));
    }
    await Promise.all(promises)
      .then(([b, patch]) => {
        notification.success({ message: 'Edited successfully!' });
        this.updateBuilds(building.siteId);
        this.updateLevels(id);
      })
      .catch(e => {
        notification.error({ message: `Error when edit building: ${e.message}` });
      });
  };

  handleLevelChange = async value => {
    const { listLevels, selSite, selBuild } = this.state;
    if (!listLevels.length) {
      return;
    }
    const selLevel = Number(value);
    const selectedLevel = listLevels.find(level => level.id === selLevel);
    this.setState({
      selLevel,
      selLevelValue: selectedLevel?.name,
      isLevelSel: true,
      selLevelRoomsCount: selectedLevel?.total
    });

    if (selectedLevel?.defProf !== null) {
      const lProf = selectedLevel.defProf;
      this.setState({
        useMainProfileLevel: true,
        levelProf: lProf
        // roomProf: lProf
      });
    } else {
      this.setState({ useMainProfileLevel: false });
      const bProf = selBuild.defProf;
      if (bProf) {
        this.setState({
          levelProf: bProf
          // roomProf: bProf
        });
      } else {
        const sProf = selSite.defProf;
        if (sProf !== null) {
          this.setState({
            levelProf: sProf
            // roomProf: sProf
          });
        } else {
          // this.setState({
          // roomProf: this.state.listProfiles[0].id
          // });
        }
      }
    }

    await this.updateRooms(value);
  };

  handleLevelDelete = () => {
    const { selLevel, selBuild } = this.state;
    if (!selLevel) {
      notification.warning({ message: 'Please select level from list!' });
    }
    api
      // @ts-ignore
      .deleteLevel(selLevel)
      .then(data => {
        notification.success({ message: 'Deleted successfully!' });
        selBuild.levelsCount = selBuild?.levelsCount - 1;
        this.setState({
          selLevel: 0,
          selSiteLevelsCount: this.state.selSiteLevelsCount - 1,
          selBuildLevelsCount: selBuild.levelsCount
        });
        this.updateLevels(selBuild.id);
      })
      .catch(e => {
        notification.error({ message: `Error when delete level! ${e.message}` });
      });
  };

  handleLevelAdd = () => {
    // @ts-ignore
    if (document.getElementById('levelName').value === '') {
      return notification.warning({ message: 'Please type level name!' });
    }

    const { selBuild, listLevels, selLevel, selLevelValue } = this.state;

    const levelAlreadyExists = listLevels.some(level => level.name === selLevelValue);

    if (levelAlreadyExists) return notification.warning({ message: 'Level with such name already exists!' });

    const data = {
      // @ts-ignore
      name: document.getElementById('levelName').value,
      // @ts-ignore
      useProfile: document.getElementById('check3').checked,
      // @ts-ignore
      buildId: selBuild.id
    };
    if (data.useProfile) {
      // @ts-ignore
      data.profileId = document.getElementById('levelProfile').value;
    }
    api
      .addLevel(data)
      .then(res => {
        selBuild.levelsCount += 1;

        this.setState({
          selSiteLevelsCount: this.state.selSiteLevelsCount + 1,
          selBuildLevelsCount: selBuild.levelsCount
        });
        notification.success({ message: 'Added successfully!' });
        this.updateLevels(selBuild.id);
      })
      .catch(e => {
        notification.error({ message: `Error when add level: ${e.message}` });
      });
  };

  handleLevelEdit = async () => {
    const { selLevel, selBuild, listLevels, selLevelValue } = this.state;

    const data = {
      // @ts-ignore
      newName: document.getElementById('levelName').value,
      // @ts-ignore
      useProfile: document.getElementById('check3').checked
    };
    if (data.useProfile) {
      // @ts-ignore
      data.profileId = parseInt(document.getElementById('levelProfile').value, 10);
    }

    api
      .editLevel(selLevel, data)
      .then(res => {
        notification.success({ message: 'Edited successfully!' });
        this.updateLevels(selBuild.id);
      })
      .catch(e => {
        notification.success({ message: `Error when edit level: ${e.message}` });
      });
  };

  handleRoomChange = value => {
    const { listRooms } = this.state;
    const roomId = Number(value);
    const room = listRooms.find(r => r.id === roomId);
    if (!room) {
      notification.error({
        message: 'Room does not exist'
      });
    }
    this.setState({
      selRoom: {
        ...room,
        sizeChanged: false
      }
    });
  };

  handleRoomNameChange = event => {
    const { selRoom } = this.state;
    const name = event.target.value;
    this.setState({
      selRoom: {
        ...selRoom,
        name
      }
    });
  };

  handleRoomSizeChange = event => {
    const { selRoom } = this.state;
    const roomSize = Number(event.target.value);
    this.setState({
      selRoom: {
        ...selRoom,
        size: roomSize,
        sizeChanged: true
      }
    });
  };

  handleSubtenantChange = subtenantId => {
    const { selRoom } = this.state;
    this.setState({
      selRoom: {
        ...selRoom,
        subtenantId
      }
    });
  };

  roomProfChanged = profileId => {
    const { selRoom } = this.state;
    this.setState({
      selRoom: {
        ...selRoom,
        profileId
      }
    });
  };

  handleRoomDelete = () => {
    const { selRoom } = this.state;
    if (!selRoom.id) {
      notification.warning({ message: 'Please select room to edit or try to create new!' });
      return;
    }
    api
      // @ts-ignore
      .deleteRoom(selRoom.id)
      .then(data => {
        this.setState({
          selSiteRoomsCount: this.state.selSiteRoomsCount - 1,
          selBuildRoomsCount: this.state.selBuildRoomsCount - 1,
          selLevelRoomsCount: this.state.selLevelRoomsCount - 1
        });
        notification.success({ message: 'Deleted successfully!' });

        this.updateRooms(this.state.selLevel);
      })
      .catch(e => {
        notification.error({ message: `Error when delete room! ${e.message}` });
      });
  };

  handleRoomAdd = event => {
    const { selRoom, selLevel: levelId, listRooms, selBuild } = this.state;
    const roomAlreadyExists = listRooms.some(room => room.name === selRoom.name);

    if (roomAlreadyExists) return notification.warning({ message: 'Room with such name already exists!' });

    if (!selRoom.name) {
      return notification.warning({ message: 'Please type room name!' });
    }

    if (!selRoom.subtenantId) {
      return notification.warning({ message: 'Please select `Subtenant` for room!' });
    }

    if (selRoom.size && selRoom.size > 255) {
      return notification.warning({ message: 'Room size can not be bigger than 255!' });
    }

    api
      .addRoom({ ...selRoom, levelId, eui: selRoom?.eui || selBuild?.eui })
      .then(res => {
        this.setState({
          selSiteRoomsCount: this.state.selSiteRoomsCount + 1,
          selBuildRoomsCount: this.state.selBuildRoomsCount + 1,
          selLevelRoomsCount: this.state.selLevelRoomsCount + 1
        });
        notification.success({ message: 'Added successfully!' });

        // @ts-ignore
        this.updateRooms(levelId);
      })
      .catch(e => {
        notification.error({ message: `Error when add room: ${e.message}` });
      });
  };

  handleRoomEdit = async () => {
    const { selRoom, listRooms } = this.state;

    const updatedRoomNames = listRooms.map(item => {
      if (item.id === selRoom.id) {
        return { ...item, name: selRoom.name };
      }
      return item;
    });

    if (!selRoom.id) {
      return notification.warning({ message: 'Please select room to edit or try to create new!' });
    }
    if (!selRoom.name) {
      return notification.warning({ message: 'Please type room name!' });
    }
    const { id, sizeChanged, ...data } = selRoom;
    const promises = [await api.editRoom(id, data)];

    if (sizeChanged) {
      if (data.size > 255) {
        return notification.warning({ message: 'Room size can not be bigger than 255!' });
      }
      promises.push(await api.patchRoomSize(id, data?.size));
    }

    api
      .editRoom(id, data)
      .then(response => {
        notification.success({ message: 'Edited successfully!' });
        this.setState({
          selRoom: {
            ...selRoom,
            sizeChanged: false,
            updatedRoomNames
          }
        });
      })
      .catch(e => {
        notification.error({
          message: `Error when edit room: ${e.message}`
        });
      });
  };

  render() {
    const profileItems = this.state.listProfiles.map(profile => (
      <Select.Option key={profile.id} value={profile.id} data-name={profile.name}>
        {profile.name}
      </Select.Option>
    ));

    return (
      <div className="rooms-wrapper">
        <Row gutter={16}>
          <SitesForm
            listSites={this.state.listSites}
            handleSiteDelete={this.handleSiteDelete}
            handleSiteEdit={this.handleSiteEdit}
            handleSiteAdd={this.handleSiteAdd}
            selSite={this.state.selSite}
            handleSiteChange={this.handleSiteChange}
            siteNameChange={this.siteNameChange}
            useMainProfileSite={this.state.useMainProfileSite}
            handleCheck1={this.handleCheck1}
            siteProf={this.state.siteProf}
            siteProfChanged={this.siteProfChanged}
            profileItems={profileItems}
            selSiteBuildsCount={this.state.selSiteBuildsCount}
            selSiteLevelsCount={this.state.selSiteLevelsCount}
            selSiteRoomsCount={this.state.selSiteRoomsCount}
          />
          {this.state.isSiteSel && (
            <BuildingForm
              profileItems={profileItems}
              listBuilds={this.state.listBuilds}
              handleBuildingDelete={this.handleBuildingDelete}
              selBuild={this.state.selBuild}
              handleBuildingsEdit={this.handleBuildingsEdit}
              handleBuildAdd={this.handleBuildAdd}
              handleBuildChange={this.handleBuildChange}
              handleBuildingNameChange={this.handleBuildingNameChange}
              handleBuildingEUIChange={this.handleBuildingEUIChange}
              useMainProfileBuild={this.state.useMainProfileBuild}
              handleCheck2={this.handleCheck2}
              buildProfChanged={this.buildProfChanged}
              selBuildLevelsCount={this.state.selBuildLevelsCount}
              selBuildRoomsCount={this.state.selBuildRoomsCount}
            />
          )}
        </Row>
        <Row gutter={16}>
          {this.state.isBuildSel && (
            <LevelsForm
              selBuildLevelsCount={this.state.selBuildLevelsCount}
              handleLevelDelete={this.handleLevelDelete}
              selLevel={this.state.selLevel}
              handleLevelEdit={this.handleLevelEdit}
              handleLevelAdd={this.handleLevelAdd}
              handleLevelChange={this.handleLevelChange}
              listLevels={this.state.listLevels}
              selLevelValue={this.state.selLevelValue}
              handleLevelNameChange={this.handleLevelNameChange}
              useMainProfileLevel={this.state.useMainProfileLevel}
              handleCheck3={this.handleCheck3}
              levelProf={this.state.levelProf}
              levelProfChanged={this.levelProfChanged}
              profileItems={profileItems}
              selLevelRoomsCount={this.state.selLevelRoomsCount}
            />
          )}

          {this.state.isLevelSel && (
            <RoomForm
              profileItems={profileItems}
              listRooms={this.state.listRooms}
              listSubtenants={this.state.listSubtenants}
              selRoom={this.state.selRoom}
              handleRoomEdit={this.handleRoomEdit}
              handleRoomChange={this.handleRoomChange}
              handleRoomAdd={this.handleRoomAdd}
              handleRoomNameChange={this.handleRoomNameChange}
              roomProfChanged={this.roomProfChanged}
              handleSubtenantChange={this.handleSubtenantChange}
              handleRoomSizeChange={this.handleRoomSizeChange}
              handleRoomDelete={this.handleRoomDelete}
            />
          )}
        </Row>
      </div>
    );
  }
}

export default observer(ListRooms);
